import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllServices, saveService } from '../services/api.service';
import ServiceList from '../components/service-list';
import Loading from '../components/loading';
import { FaTimes } from 'react-icons/fa';
import Helper from '../services/helper.service';

const ServicesListPage = () => {
    const [search, setSearch] = useState('');
    const [services, setServices] = useState([]);
    const [filteredServices, setFilteredServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchServices = async () => {
            setLoading(true);

            try {
                const data = await getAllServices();
                setServices(data);
                setFilteredServices(data);

            } catch (err) {
                Helper.toast("Erreur lors du chargement des services", "error");

            } finally {
                setLoading(false);
            }
        };
        fetchServices();
    }, []);

    useEffect(() => {
        setFilteredServices(
            services.filter((s) =>
                s.title.fr?.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search, services]);

    const toggleVisibility = async (updatedService) => {
        try {
            await saveService(updatedService);
            setServices((prev) =>
                prev.map((s) =>
                    s._id === updatedService._id ? updatedService : s
                )
            );
        } catch {
            Helper.toast("Erreur lors de la mise à jour de la visibilité", "error");
        }
    };

    return (
        <section className="max-w-7xl mx-auto p-6">
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Gestion des services</h1>
            </div>

            <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
                <div className="relative w-full md:max-w-md">
                    <input
                        type="text"
                        className="w-full border border-gray-300 p-2 pr-10 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Rechercher un service"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    {search && (
                        <button
                            onClick={() => setSearch('')}
                            className="absolute right-3 top-3 text-gray-500 text-lg"
                        >
                            <FaTimes className="w-4 h-4" />
                        </button>
                    )}
                </div>
                <button
                    className="bg-primary hover:bg-blue-700 text-white px-4 py-2 rounded shadow"
                    onClick={() => navigate('/service/new')}
                >
                    Ajouter un service
                </button>
            </div>

            {loading ? (
                <div className="flex justify-center py-24">
                    <Loading />
                </div>
            ) : (
                <ServiceList
                    services={filteredServices}
                    onEdit={(service) => navigate(`/service/${service._id}`)}
                    onToggleVisibility={toggleVisibility}
                />
            )}
        </section>
    );
};

export default ServicesListPage;